import react, { Fragment, useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import { useHistory, useLocation } from "react-router-dom";
import { ramactions } from "../store/index";
import useCustomquesrystring from "../hooks/use-querystring";
import LanguageFilterDropdown from "./Filters/LanguageFilterDropdown";
import ResourcesFilterDropdown from "./Filters/ResourcesFilterDropdown";
import FilterButton from "./Filters/FilterButton";
import CommunityFilterDropdown from "./Filters/CommunityFilterDropdown";
import AccessibilityFilter from "./Filters/AccessibilityFilter";
import CostFilter from "./Filters/CostFilter";
import { useTranslation } from "react-i18next";
const getScreenWidth = () => {
  return window.innerWidth;
};
const Dropdowns = (props) => {
  const { t } = useTranslation("translation", { keyPrefix: "dropdown" });
  const webLanguage = localStorage.getItem("lang");
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const resourceType = useSelector((state) => state.resourceType);
  const resourceType_prev = useSelector((state) => state.resourceType_prev);
  const languages = useSelector((state) => state.languages);
  const languages_prev = useSelector((state) => state.languages_prev);
  const communities = useSelector((state) => state.communities);
  const communities_prev = useSelector((state) => state.communities_prev);
  const accessibility = useSelector((state) => state.accessibility);
  const accessibility_prev = useSelector((state) => state.accessibility_prev);
  const cost = useSelector((state) => state.cost);
  const cost_prev = useSelector((index) => index.cost_prev);
  const subCategoryId = useSelector((index) => index.subCategoryId);
  const place = useSelector((index) => index.place);
  const searchBy = useSelector((state) => state.searchBy);
  const keyword = useSelector((state) => state.keyword);
  const totolhotline = useSelector((state) => state.totolhotline);
  const [showclear, setShowclear] = useState(false);
  const [totalLang, setTotalLang] = useState(0);
  const [totalAccessibility, setTotalAccessibility] = useState(0);
  const [totalCommunities, setTotalCommunities] = useState(0);
  const [totalCost, setTotalCost] = useState(0);
  const isPogress = useSelector((index) => index.isPogress);
  const [langFilterEnabled, setLangFilterEnabled] = useState(false);
  const [communityFilterEnabled, setCommunityFilterEnabled] = useState(false);
  const [accessibilityFilterEnabled, setAccessibilityFilterEnabled] =
    useState(false);
  const [costFilterEnabled, setCostFilterEnabled] = useState(false);
  const [helplineFilterEnabled, setHelplineFilterEnabled] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const customquery = useCustomquesrystring();
  const [isLangPrevstore, setIsLangPrevstore] = useState(true);
  const [isAccessibilityPrevstore, setIsAccessibilityPrevstore] =
    useState(true);
  const [isCostPrevstore, setIsCostPrevstore] = useState(true);
  const [isCommunitiesPrevstore, setIsCommunitiesPrevstore] = useState(true);
  const [isResourceTypePrevstore, setIsResourceTypePrevstore] = useState(true);
  const [userText, setUserText] = useState("");
  const rearchresults = useSelector((index) => index.rearchresults);
  //const isApicallneeded = useSelector((index) => index.isApicallneeded);
  const isApicallneeded = true;
  useEffect(() => {
    if (
      (resourceType.indexOf("any") === -1 && resourceType.length > 0) ||
      (languages.indexOf("any") === -1 && languages.length > 0) ||
      (communities.indexOf("any") === -1 && communities.length > 0) ||
      (accessibility.indexOf("any") === -1 && accessibility.length > 0) ||
      (cost.indexOf("any") === -1 && cost.length > 0)
    )
      setShowclear(true);
    else setShowclear(false);
  }, [resourceType, languages, communities, accessibility, cost]);
  useEffect(() => {
    if (
      props.languagesOfferedDropdown !== undefined &&
      props.languagesOfferedDropdown.length > 0
    ) {
      setTotalLang(
        props.languagesOfferedDropdown.reduce(
          (total, current) => total + current.count,
          0
        )
      );
    }

    if (
      props.disabilitiesAccessDropdown !== undefined &&
      props.disabilitiesAccessDropdown.length > 0
    ) {
      setTotalAccessibility(
        props.disabilitiesAccessDropdown.reduce(
          (total, current) => total + current.count,
          0
        )
      );
    }

    if (
      props.targetPopulationDropdown !== undefined &&
      props.targetPopulationDropdown.length > 0
    ) {
      setTotalCommunities(
        props.targetPopulationDropdown.reduce(
          (total, current) => total + current.count,
          0
        )
      );
    }

    if (
      props.feeStructureDropdown !== undefined &&
      props.feeStructureDropdown.length > 0
    ) {
      setTotalCost(
        props.feeStructureDropdown.reduce(
          (total, current) => total + current.count,
          0
        )
      );
    }
    populateDropdowns();
    function handleResize() {
      setTimeout(() => {
        setWindowWidth(getScreenWidth());
      }, 100);
    }
    window.addEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    if (
      (langFilterEnabled ||
        communityFilterEnabled ||
        accessibilityFilterEnabled ||
        costFilterEnabled ||
        helplineFilterEnabled) &&
      windowWidth < 992
    ) {
      hideAllDOM();
    } else if (windowWidth > 991.98) {
      showAllDOM();
    }
  }, [windowWidth]);
  const hideAllDOM = () => {
    document.querySelector("#main-header").style.display = "none";
    document.querySelector("#page").style.display = "none";
    document.querySelector(".js-mobile-navigation").style.display = "none";
  };
  const showAllDOM = () => {
    document.querySelector("#main-header").style.display = "";
    document.querySelector("#page").style.display = "";
    document.querySelector(".js-mobile-navigation").style.display = "";
  };

  useEffect(() => {
    window.addEventListener("click", handleUserClick);
    window.addEventListener("keydown", handleUserKeyPress);

    return () => {
      window.removeEventListener("click", handleUserClick);
      window.addEventListener("keydown", handleUserKeyPress);
    };
  });

  useEffect(() => {
    if (props.isClearClick) {
      clearAllFilter();
    }
  }, [props.isClearClick]);

  const handleUserKeyPress = async (e) => {
    if (e.code === "Escape") {
      /*if (
        langFilterEnabled ||
        communityFilterEnabled ||
        accessibilityFilterEnabled ||
        costFilterEnabled ||
        helplineFilterEnabled
      ) {
        await populateDropdowns();
        hideAll();
      }*/
      if (langFilterEnabled) {
        if (languages_prev.length > 0)
          dispatch(ramactions.updateLanguages(languages_prev));
      }
      if (communityFilterEnabled) {
        if (communities_prev.length > 0)
          dispatch(ramactions.updateCommunities(communities_prev));
      }
      if (accessibilityFilterEnabled) {
        if (accessibility_prev.length > 0)
          dispatch(ramactions.updateAccessibility(accessibility_prev));
      }
      if (costFilterEnabled) {
        if (cost_prev.length > 0) dispatch(ramactions.updateCost(cost_prev));
      }
      if (helplineFilterEnabled) {
        if (resourceType_prev.length > 0)
          dispatch(ramactions.updateResourceType(resourceType_prev));
      }
      hideAll();
    }
  };

  const handleUserClick = async (e) => {
    if (
      e.target.closest(".filter-type, .select-dropdown") === null ||
      e.target.closest(".filter-type, .select-dropdown") === "NULL" ||
      e.target.closest(".filter-type, .select-dropdown") === undefined
    ) {
      if (langFilterEnabled) {
        if (languages_prev.length > 0)
          dispatch(ramactions.updateLanguages(languages_prev));
      }
      if (communityFilterEnabled) {
        if (communities_prev.length > 0)
          dispatch(ramactions.updateCommunities(communities_prev));
      }
      if (accessibilityFilterEnabled) {
        if (accessibility_prev.length > 0)
          dispatch(ramactions.updateAccessibility(accessibility_prev));
      }
      if (costFilterEnabled) {
        if (cost_prev.length > 0) dispatch(ramactions.updateCost(cost_prev));
      }
      if (helplineFilterEnabled) {
        if (resourceType_prev.length > 0)
          dispatch(ramactions.updateResourceType(resourceType_prev));
      }
      /*if (
        langFilterEnabled ||
        communityFilterEnabled ||
        accessibilityFilterEnabled ||
        costFilterEnabled ||
        helplineFilterEnabled
      ) {
        await populateDropdowns();
        hideAll();
      }*/
      hideAll();
    }

    //hideAll();
    /*console.log("Event called....");
    console.log(langFilterEnabled);
    const { key, keyCode } = event;

    if (keyCode === 32 || (keyCode >= 65 && keyCode <= 90)) {
      setUserText(`${userText}${key}`);
    }*/
  };

  const changeresourcestype = (e) => {
    if (isResourceTypePrevstore) {
      dispatch(ramactions.updateResourceTypePrev(resourceType));
      setIsResourceTypePrevstore(false);
    }
    if (e.target.checked === true) {
      dispatch(
        ramactions.updateResourceType([...resourceType, e.target.value])
      );
      if (e.target.value === "any") {
        dispatch(ramactions.updateResourceType([e.target.value]));
      } else {
        const newarr = [...resourceType, e.target.value];
        dispatch(
          ramactions.updateResourceType(
            newarr.filter((itemval) => itemval !== "any")
          )
        );
      }
    } else {
      dispatch(
        ramactions.updateResourceType(
          resourceType.filter((langitem) => {
            if (langitem !== e.target.value) return langitem;
          })
        )
      );
    }
  };

  const changelanghanddler = async (e) => {
    if (isLangPrevstore) {
      dispatch(ramactions.updateLanguagesPrev(languages));
      setIsLangPrevstore(false);
    }
    if (e.target.checked === true) {
      dispatch(ramactions.updateLanguages([...languages, e.target.value]));
      //setSelectedlangvalue([...selectedlangvalue, e.target.value]);
      if (e.target.value === "any") {
        dispatch(ramactions.updateLanguages([e.target.value]));
        //setSelectedlangvalue([e.target.value]);
      } else {
        const newlangarr = [...languages, e.target.value];
        //setSelectedlangvalue(newlangarr.filter((itemval) => itemval !== "any"));
        dispatch(
          ramactions.updateLanguages(
            newlangarr.filter((itemval) => itemval !== "any")
          )
        );
      }
    } else {
      dispatch(
        ramactions.updateLanguages(
          languages.filter((langitem) => {
            if (langitem !== e.target.value) return langitem;
          })
        )
      );
    }
  };

  const changepopulationhanddler = (e) => {
    if (isCommunitiesPrevstore) {
      dispatch(ramactions.updateCommunitiesPrev(communities));
      setIsCommunitiesPrevstore(false);
    }
    if (e.target.checked === true) {
      dispatch(ramactions.updateCommunities([...communities, e.target.value]));
      if (e.target.value === "any") {
        //console.log("here");
        dispatch(ramactions.updateCommunities([e.target.value]));
      } else {
        const newcommunitiesarr = [...communities, e.target.value];
        //console.log(newcommunitiesarr);
        dispatch(
          ramactions.updateCommunities(
            newcommunitiesarr.filter((itemval) => itemval !== "any")
          )
        );
      }
    } else {
      dispatch(
        ramactions.updateCommunities(
          communities.filter((item) => {
            if (item !== e.target.value) return item;
          })
        )
      );
    }
  };

  const changedisabilitieshanddler = (e) => {
    if (isAccessibilityPrevstore) {
      dispatch(ramactions.updateAccessibilityPrev(accessibility));
      setIsAccessibilityPrevstore(false);
    }
    if (e.target.checked === true) {
      dispatch(
        ramactions.updateAccessibility([...accessibility, e.target.value])
      );
      if (e.target.value === "any") {
        //console.log("here");
        dispatch(ramactions.updateAccessibility([e.target.value]));
      } else {
        const newarr = [...accessibility, e.target.value];
        //console.log(newcommunitiesarr);
        dispatch(
          ramactions.updateAccessibility(
            newarr.filter((itemval) => itemval !== "any")
          )
        );
      }
    } else {
      dispatch(
        ramactions.updateAccessibility(
          accessibility.filter((item) => {
            if (item !== e.target.value) return item;
          })
        )
      );
    }
  };

  const changefeeStructurehanddler = (e) => {
    if (isCostPrevstore) {
      dispatch(ramactions.updateCostPrev(cost));
      setIsCostPrevstore(false);
    }
    if (e.target.checked === true) {
      dispatch(ramactions.updateCost([...cost, e.target.value]));
      if (e.target.value === "any") {
        dispatch(ramactions.updateCost([e.target.value]));
      } else {
        const newarr = [...cost, e.target.value];
        dispatch(
          ramactions.updateCost(newarr.filter((itemval) => itemval !== "any"))
        );
      }
    } else {
      dispatch(
        ramactions.updateCost(
          cost.filter((item) => {
            if (item !== e.target.value) return item;
          })
        )
      );
    }
  };

  const clearAllFilter = async () => {
    setShowclear(false);
    resetFilter();
    await populateDropdowns(5);
  };

  const resetFilter = () => {
    dispatch(ramactions.updateResourceType(["any"]));
    dispatch(ramactions.updateLanguages(["any"]));
    dispatch(ramactions.updateCommunities(["any"]));
    dispatch(ramactions.updateAccessibility(["any"]));
    dispatch(ramactions.updateCost(["any"]));
  };

  const showResult = async () => {
    //dispatch(ramactions.updateLoaderDisplay(false));
    await populateDropdowns(2, false);
  };

  const populateDropdowns = async (clear = 2) => {
    if (isApicallneeded) {
      //console.log("Here I am!!");
      if (windowWidth < 992) {
        showAllDOM();
      }
      props.onDropdownchange(clear);
      dispatch(ramactions.addSearchresult([]));
      dispatch(ramactions.changePogress(true));
      dispatch(ramactions.updateEtlID(""));
      dispatch(ramactions.updateLanguagesPrev([]));
      dispatch(ramactions.updateCostPrev([]));
      dispatch(ramactions.updateAccessibilityPrev([]));
      dispatch(ramactions.updateCommunitiesPrev([]));
      dispatch(ramactions.updateResourceTypePrev([]));
      setIsLangPrevstore(true);
      setIsAccessibilityPrevstore(true);
      setIsCostPrevstore(true);
      setIsResourceTypePrevstore(true);
      setIsCommunitiesPrevstore(true);
      //console.log(cost);
      let langParams;
      let communitiesParams;
      let accessibilityParams;
      let costParams;
      let resourceTypeParams;

      if (clear === 5) {
        langParams = "any";
        communitiesParams = "any";
        accessibilityParams = "any";
        costParams = "any";
        resourceTypeParams = "hotline,physical";
      } else {
        langParams = customquery.langParams;
        communitiesParams = customquery.communitiesParams;
        accessibilityParams = customquery.accessibilityParams;
        costParams = customquery.costParams;
        resourceTypeParams = customquery.resourceTypeParams;
      }

      if (queryParams.has("resourceType")) {
        queryParams.delete("resourceType");
      }

      if (queryParams.has("languages")) {
        queryParams.delete("languages");
      }

      if (queryParams.has("communities")) {
        queryParams.delete("communities");
      }

      if (queryParams.has("accessibilities")) {
        queryParams.delete("accessibilities");
      }

      if (queryParams.has("costs")) {
        queryParams.delete("costs");
      }
      //console.log(languages.toString());
      history.replace({
        search:
          queryParams.toString() +
          "&resourceType=" +
          resourceTypeParams +
          "&languages=" +
          langParams +
          "&communities=" +
          communitiesParams +
          "&accessibilities=" +
          accessibilityParams +
          "&costs=" +
          costParams,
      });

      try {
        let response;
        if (searchBy === "topic") {
          /*console.log(
            process.env.REACT_APP_REACT_APP_API_END_POINT +
              process.env.REACT_APP_GET_RESOURCES_BY_SUBCATEGORY +
              "en/" +
              subCategoryId +
              "/" +
              resourceTypeParams +
              "/" +
              place.latitude +
              "/" +
              place.longitude +
              "/" +
              langParams +
              "/" +
              communitiesParams +
              "/" +
              accessibilityParams +
              "/" +
              costParams +
              "?code=" +
              process.env.REACT_APP_API_KEY
          );*/

          response = await axios.get(
            process.env.REACT_APP_REACT_APP_API_END_POINT +
              process.env.REACT_APP_GET_RESOURCES_BY_SUBCATEGORY +
              webLanguage +
              "/" +
              subCategoryId +
              "/" +
              resourceTypeParams +
              "/" +
              place.latitude +
              "/" +
              place.longitude +
              "/" +
              langParams +
              "/" +
              communitiesParams +
              "/" +
              accessibilityParams +
              "/" +
              costParams +
              "?code=" +
              process.env.REACT_APP_API_KEY
          );
        } else {
          /*console.log(
            process.env.REACT_APP_REACT_APP_API_END_POINT +
              process.env.REACT_APP_GET_RESOURCES_BY_KEYWORD +
              "en/" +
              keyword +
              "/" +
              resourceTypeParams +
              "/" +
              place.latitude +
              "/" +
              place.longitude +
              "/" +
              langParams +
              "/" +
              communitiesParams +
              "/" +
              accessibilityParams +
              "/" +
              costParams +
              "?code=" +
              process.env.REACT_APP_API_KEY
          );*/

          response = await axios.get(
            process.env.REACT_APP_REACT_APP_API_END_POINT +
              process.env.REACT_APP_GET_RESOURCES_BY_KEYWORD +
              webLanguage +
              "/" +
              keyword +
              "/" +
              resourceTypeParams +
              "/" +
              place.latitude +
              "/" +
              place.longitude +
              "/" +
              langParams +
              "/" +
              communitiesParams +
              "/" +
              accessibilityParams +
              "/" +
              costParams +
              "?code=" +
              process.env.REACT_APP_API_KEY
          );
        }
        //console.log(response.data.data);
        if (response.data.data.Hotlines === undefined)
          response.data.data.Hotlines = [];
        if (response.data.data.PhysicalLocations === undefined)
          response.data.data.PhysicalLocations = [];
        if (response.data.data.stickyLocations === undefined)
          response.data.data.stickyLocations = [];
        const resourcesData = [
          ...response.data.data.stickyLocations,
          ...response.data.data.Hotlines,
          ...response.data.data.PhysicalLocations,
        ];
        //console.log(response.data);
        dispatch(
          ramactions.updateTotolhotline(response.data.data.Hotlines.length)
        );
        dispatch(
          ramactions.updateTotolsticky(response.data.data.stickyLocations.length)
        );
        dispatch(
          ramactions.updateTotolphysical(
            response.data.data.PhysicalLocations.length
          )
        );
        dispatch(ramactions.addSearchresult(resourcesData));
        dispatch(ramactions.changePogress(false));
      } catch (err) {
        //console.log(err);
        dispatch(ramactions.changePogress(true));
        dispatch(ramactions.updateErrormsg(err));
        dispatch(ramactions.updateErrorstatus(1));
      }
      hideAll();
    } else {
      dispatch(ramactions.updateApiCall(true));
      dispatch(ramactions.changePogress(false));
    }
    dispatch(ramactions.updateLoaderDisplay(true));
  };

  const hideAll = () => {
    setLangFilterEnabled(false);
    setCommunityFilterEnabled(false);
    setAccessibilityFilterEnabled(false);
    setCostFilterEnabled(false);
    setHelplineFilterEnabled(false);
  };

  const showLangFilter = () => {
    hideAll();
    setLangFilterEnabled(true);
    // headerLevel("down");
    if (windowWidth < 992) {
      hideAllDOM();
    }
  };
  const closeLangFilter = () => {
    //console.log(languages_prev);
    if (languages_prev.length > 0)
      dispatch(ramactions.updateLanguages(languages_prev));
    setLangFilterEnabled(false);
    // headerLevel("clear");
    if (windowWidth < 992) {
      showAllDOM();
    }
  };
  const showCommunityFilter = () => {
    hideAll();
    setCommunityFilterEnabled(true);
    // headerLevel("down");
    if (windowWidth < 992) {
      hideAllDOM();
    }
  };
  const closeCommunityFilter = () => {
    if (communities_prev.length > 0)
      dispatch(ramactions.updateCommunities(communities_prev));
    setCommunityFilterEnabled(false);
    // headerLevel("clear");
    if (windowWidth < 992) {
      showAllDOM();
    }
  };
  const showAccessibilityFilter = () => {
    hideAll();
    setAccessibilityFilterEnabled(true);
    // headerLevel("down");
    if (windowWidth < 992) {
      hideAllDOM();
    }
  };
  const closeAccessibilityFilter = () => {
    if (accessibility_prev.length > 0)
      dispatch(ramactions.updateAccessibility(accessibility_prev));
    setAccessibilityFilterEnabled(false);
    // headerLevel("clear");
    if (windowWidth < 992) {
      showAllDOM();
    }
  };
  const showCostFilter = () => {
    hideAll();
    setCostFilterEnabled(true);
    // headerLevel("down");
    if (windowWidth < 992) {
      hideAllDOM();
    }
  };
  const closeCostFilter = () => {
    if (cost_prev.length > 0) dispatch(ramactions.updateCost(cost_prev));
    setCostFilterEnabled(false);
    // headerLevel("clear");
    if (windowWidth < 992) {
      showAllDOM();
    }
  };
  const showHelplineFilter = () => {
    hideAll();
    setHelplineFilterEnabled(true);
    // headerLevel("down");
    if (windowWidth < 992) {
      hideAllDOM();
    }
  };
  const closeHelplineFilter = () => {
    if (resourceType_prev.length > 0)
      dispatch(ramactions.updateResourceType(resourceType_prev));
    setHelplineFilterEnabled(false);
    // headerLevel("clear");
    if (windowWidth < 992) {
      showAllDOM();
    }
  };

  return (
    <Fragment>
      {!isPogress && (
        <div className="dropdown-filter-wrap">
          <div class="dropdown-filters">
            {rearchresults.length > 0 && (
              <div class="filter-type">
                <FilterButton
                  enableFilter={showHelplineFilter}
                  getFilterType={resourceType}
                  buttonText={t("resources_include")}
                  isExpanded={helplineFilterEnabled}
                ></FilterButton>

                {helplineFilterEnabled && windowWidth < 992 ? (
                  // Modal used for small device WCAG/Accessibility
                  <Modal
                    isOpen={helplineFilterEnabled}
                    onRequestClose={closeHelplineFilter}
                    contentLabel="Modal"
                    className="filter-modal"
                  >
                    <ResourcesFilterDropdown
                      closeResourcesFilter={closeHelplineFilter}
                      getResourceType={resourceType}
                      getChangeResourceType={changeresourcestype}
                      getTotolhotline={totolhotline}
                      getPopulateDropdowns={showResult}
                      getWindowWidth={windowWidth}
                    ></ResourcesFilterDropdown>
                  </Modal>
                ) : (
                  helplineFilterEnabled && (
                    <ResourcesFilterDropdown
                      closeResourcesFilter={closeHelplineFilter}
                      getResourceType={resourceType}
                      getChangeResourceType={changeresourcestype}
                      getTotolhotline={totolhotline}
                      getPopulateDropdowns={showResult}
                      getWindowWidth={windowWidth}
                    ></ResourcesFilterDropdown>
                  )
                )}
              </div>
            )}

            {props.languagesOfferedDropdown.length > 0 &&
              rearchresults.length > 0 && (
                <div class="filter-type">
                  <FilterButton
                    enableFilter={showLangFilter}
                    getFilterType={languages}
                    buttonText={t("languages_offered")}
                    isExpanded={langFilterEnabled}
                  ></FilterButton>

                  {langFilterEnabled && windowWidth < 992 ? (
                    // Modal used for small device WCAG/Accessibility
                    <Modal
                      isOpen={langFilterEnabled}
                      onRequestClose={closeLangFilter}
                      contentLabel="Modal"
                      className="filter-modal"
                    >
                      <LanguageFilterDropdown
                        closeLangFilter={closeLangFilter}
                        getWindowWidth={windowWidth}
                        getChangelanghanddler={changelanghanddler}
                        getLanguages={languages}
                        languagesList={props.languagesOfferedDropdown}
                        getpopulateDropdowns={showResult}
                      ></LanguageFilterDropdown>
                    </Modal>
                  ) : (
                    langFilterEnabled && (
                      <LanguageFilterDropdown
                        closeLangFilter={closeLangFilter}
                        getWindowWidth={windowWidth}
                        getChangelanghanddler={changelanghanddler}
                        getLanguages={languages}
                        languagesList={props.languagesOfferedDropdown}
                        getpopulateDropdowns={showResult}
                      ></LanguageFilterDropdown>
                    )
                  )}
                </div>
              )}

            {props.targetPopulationDropdown.length > 0 &&
              rearchresults.length > 0 && (
                <div class="filter-type">
                  <FilterButton
                    enableFilter={showCommunityFilter}
                    getFilterType={communities}
                    buttonText={t("communities_supported")}
                    isExpanded={communityFilterEnabled}
                  ></FilterButton>

                  {communityFilterEnabled && windowWidth < 992 ? (
                    // Modal used for small device WCAG/Accessibility
                    <Modal
                      isOpen={communityFilterEnabled}
                      onRequestClose={closeCommunityFilter}
                      contentLabel="Modal"
                      className="filter-modal"
                    >
                      <CommunityFilterDropdown
                        closeCommunityFilter={closeCommunityFilter}
                        getWindowWidth={windowWidth}
                        getchangepopulationhanddler={changepopulationhanddler}
                        getCommunities={communities}
                        populationList={props.targetPopulationDropdown}
                        getPopulateDropdowns={showResult}
                      ></CommunityFilterDropdown>
                    </Modal>
                  ) : (
                    communityFilterEnabled && (
                      <CommunityFilterDropdown
                        closeCommunityFilter={closeCommunityFilter}
                        getWindowWidth={windowWidth}
                        getchangepopulationhanddler={changepopulationhanddler}
                        getCommunities={communities}
                        populationList={props.targetPopulationDropdown}
                        getPopulateDropdowns={showResult}
                      ></CommunityFilterDropdown>
                    )
                  )}
                </div>
              )}

            {props.disabilitiesAccessDropdown.length > 0 &&
              rearchresults.length > 0 && (
                <div class="filter-type">
                  <FilterButton
                    enableFilter={showAccessibilityFilter}
                    getFilterType={accessibility}
                    buttonText={t("accessibility")}
                    isExpanded={accessibilityFilterEnabled}
                  ></FilterButton>

                  {accessibilityFilterEnabled && windowWidth < 992 ? (
                    // Modal used for small device WCAG/Accessibility
                    <Modal
                      isOpen={accessibilityFilterEnabled}
                      onRequestClose={closeAccessibilityFilter}
                      contentLabel="Modal"
                      className="filter-modal"
                    >
                      <AccessibilityFilter
                        closeAccessibilityFilter={closeAccessibilityFilter}
                        getWindowWidth={windowWidth}
                        getChangedisabilitieshanddler={
                          changedisabilitieshanddler
                        }
                        getAccessibility={accessibility}
                        accessibilityList={props.disabilitiesAccessDropdown}
                        getPopulateDropdowns={showResult}
                      ></AccessibilityFilter>
                    </Modal>
                  ) : (
                    accessibilityFilterEnabled && (
                      <AccessibilityFilter
                        closeAccessibilityFilter={closeAccessibilityFilter}
                        getWindowWidth={windowWidth}
                        getChangedisabilitieshanddler={
                          changedisabilitieshanddler
                        }
                        getAccessibility={accessibility}
                        accessibilityList={props.disabilitiesAccessDropdown}
                        getPopulateDropdowns={showResult}
                      ></AccessibilityFilter>
                    )
                  )}
                </div>
              )}
            {props.feeStructureDropdown.length > 0 && rearchresults.length > 0 && (
              <div class="filter-type">
                <FilterButton
                  enableFilter={showCostFilter}
                  getFilterType={cost}
                  buttonText={t("cost")}
                  isExpanded={costFilterEnabled}
                ></FilterButton>

                {costFilterEnabled && windowWidth < 992 ? (
                  // Modal used for small device WCAG/Accessibility
                  <Modal
                    isOpen={costFilterEnabled}
                    onRequestClose={closeCostFilter}
                    contentLabel="Modal"
                    className="filter-modal"
                  >
                    <CostFilter
                      closeCostFilter={closeCostFilter}
                      getWindowWidth={windowWidth}
                      getChangefeeStructurehanddler={changefeeStructurehanddler}
                      getCost={cost}
                      costList={props.feeStructureDropdown}
                      getPopulateDropdowns={showResult}
                    ></CostFilter>
                  </Modal>
                ) : (
                  costFilterEnabled && (
                    <CostFilter
                      closeCostFilter={closeCostFilter}
                      getWindowWidth={windowWidth}
                      getChangefeeStructurehanddler={changefeeStructurehanddler}
                      getCost={cost}
                      costList={props.feeStructureDropdown}
                      getPopulateDropdowns={showResult}
                    ></CostFilter>
                  )
                )}
              </div>
            )}
            {windowWidth > 991.98 && showclear && (
              <Link className="clear-fllters" onClick={clearAllFilter}>
                {t("clear_all_filter")}
              </Link>
            )}
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default Dropdowns;
